<template>
    <el-dialog
        :title="title"
        :visible.sync="defentDialogVisible"
        width="1000px"
        @close="closeDialog"
        :close-on-click-modal="false"
        :destroy-on-close="true"
        class="defentDialogClass leader-dialog"
    >
        <div style="display: flex;height: 100%">
            <div style="width: 230px;height: 100%" v-show="!lookLook">
                <el-scrollbar style="height: 82%">
                    <me-tree
                        style="height: 500px;"
                        ref="myTree"
                        :treeData="treeData"
                        :treeLoading="treeLoading"
                        :treeToolBar="false"
                        :defaultProps="defaultProps"
                        :nodeKey="'tree_id'"
                        :defaultExpandedKeys="defaultCheckKeys"
                        :showCheckbox="true"
                        :isCheckClick="true"
                        :checkStrictly="true"
                        :isSingle="true"
                        :defaultCheckKeys="defaultCheckKeys"
                        @handleCheckBoxClick="handleTreeNodeClick"
                    ></me-tree>
                </el-scrollbar>
            </div>
            <div style="flex:1;height: 470px;">
                <el-scrollbar style="height: 100%">
                    <el-form
                        class="leader-style-form"
                        :rules="defentCheckFormRules"
                        :model="defentCheckForm"
                        ref="defentCheckForm"
                    >
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item
                                    label="缺陷来源"
                                    :label-width="labelWidth"
                                    prop="defect_source"
                                >
                                    <el-select
                                        v-model="defentCheckForm.defect_source"
                                        style="width: 100%"
                                        :disabled="lookLook"
                                    >
                                        <el-option
                                            v-for="item in defectSource"
                                            :key="item.code_value"
                                            :label="item.code_name"
                                            :value="item.code_value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="缺陷性质"
                                    :label-width="labelWidth"
                                    prop="defect_level"
                                >
                                    <el-select
                                        v-model="defentCheckForm.defect_level"
                                        style="width: 100%"
                                        :disabled="lookLook"
                                    >
                                        <el-option
                                            v-for="item in defectLevels"
                                            :key="item.code_value"
                                            :label="item.code_name"
                                            :value="item.code_value"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="缺陷发现人"
                                    :label-width="labelWidth"
                                    prop="founder"
                                >
                                    <el-input
                                        :disabled="lookLook"
                                        maxlength="50"
                                        v-model="defentCheckForm.founder"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="联系电话"
                                    :label-width="labelWidth"
                                    prop="founder_phone"
                                >
                                    <el-input
                                        :disabled="lookLook"
                                        maxlength="50"
                                        v-model="defentCheckForm.founder_phone"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item
                                    label="缺陷发现日期"
                                    :label-width="labelWidth"
                                    prop="found_time"
                                >
                                    <el-date-picker
                                        v-model="defentCheckForm.found_time"
                                        type="date"
                                        placeholder="选择日期"
                                        :default-value="timeNow"
                                        value-format="yyyy-MM-dd"
                                        format="yyyy-MM-dd"
                                        style="width: 100%"
                                        :picker-options="pickerOptions"
                                        :disabled="lookLook"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="24">
                                <el-form-item
                                    label="缺陷内容"
                                    style="width: 100%;"
                                    prop="defect_content"
                                    :label-width="labelWidth"
                                >
                                    <el-input
                                        type="textarea"
                                        :disabled="lookLook"
                                        v-model="defentCheckForm.defect_content"
                                        rows="2"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item
                                    label="消缺安排处理"
                                    :label-width="labelWidth"
                                    prop="dual_method"
                                >
                                    <el-radio-group
                                        class="leader-style-radio"
                                        v-model="defentCheckForm.dual_method"
                                        :disabled="lookLook"
                                    >
                                        <el-radio label="10">需要安排处理</el-radio>
                                        <el-radio label="20">直接消缺</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="缺陷图片" :label-width="labelWidth">
                                    <el-upload
                                        class="avatar-uploader"
                                        action
                                        multiple
                                        :http-request="uploadFile"
                                        list-type="picture-card"
                                        :file-list="qxFileImgs"
                                        :on-remove="handleRemove"
                                        accept=".jpg, , jpeg, .png, .gif, .bmp"
                                        style="margin-left:0;"
                                    >
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-card
                            class="box-card"
                            style="color: #fff;background-color: transparent;border: 0px;"
                            v-if="defentCheckForm.dual_method == '20'"
                        >
                            <div slot="header" class="clearfix">
                                <span>缺陷处理</span>
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item
                                        label="消缺开始时间"
                                        :label-width="labelWidth"
                                        prop="solve_time_start"
                                    >
                                        <el-date-picker
                                            :disabled="lookLook"
                                            v-model="
                                                defentCheckForm.solve_time_start
                                            "
                                            type="date"
                                            placeholder="选择日期"
                                            :default-value="timeNow"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            :picker-options="pickerOptions"
                                        ></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item
                                        label="消缺结束时间"
                                        :label-width="labelWidth"
                                        prop="solve_time_end"
                                    >
                                        <el-date-picker
                                            :disabled="lookLook"
                                            v-model="
                                                defentCheckForm.solve_time_end
                                            "
                                            type="date"
                                            placeholder="选择日期"
                                            :default-value="timeNow"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            :picker-options="pickerOptions"
                                        ></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item
                                        label="缺陷负责人"
                                        :label-width="labelWidth"
                                        prop="solver"
                                    >
                                        <el-input
                                            :disabled="lookLook"
                                            v-model="defentCheckForm.solver"
                                            maxlength="50"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item label="消缺图片" :label-width="labelWidth">
                                        <el-upload
                                            class="avatar-uploader"
                                            action
                                            multiple
                                            :http-request="uploadFile_xq"
                                            list-type="picture-card"
                                            :file-list="xqFileImgs"
                                            :on-remove="handleRemove_xq"
                                            accept=".jpg, , jpeg, .png, .gif, .bmp"
                                        >
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="24">
                                    <el-form-item
                                        label="缺陷过程描述"
                                        style="width: 100%;"
                                        prop="solve_content"
                                        :label-width="labelWidth"
                                    >
                                        <el-input
                                            :disabled="lookLook"
                                            type="textarea"
                                            v-model="
                                                defentCheckForm.solve_content
                                            "
                                            rows="4"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-form>
                </el-scrollbar>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" v-if="!lookLook">
            <el-button @click="defentDialogVisible = false" class="leader-common-button">取消</el-button>
            <el-button
                type="primary"
                @click="changeCommit('defentCheckForm')"
                :loading="this.$store.state.btnType"
                class="leader-common-button"
            >保存</el-button>
        </div>
    </el-dialog>
</template>
<script>
import Tree from '@/comon/components/tree.vue';
import * as api from '../api/index';
export default {
    components: {
        'me-tree': Tree,
    },
    props: {
        title: {
            type: String,
            default: '登记缺陷',
        },
        defect_id: {
            type: String,
        },
        lookLook: Boolean,
        defentDialogVisible: Boolean,
    },
    data() {
        return {
            labelWidth: '120px',
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            treeLoading: false,
            treeData: [],
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            defaultExpandedKeys: [],
            defaultCheckKeys: [],
            tree_id: '',
            defectSource: [],
            defectLevels: [],
            defentCheckForm: {
                defect_source: '', //缺陷来源
                defect_level: '', //缺陷性质
                founder: '', //缺陷发现人
                founder_phone: '', //发现人电话
                found_time: '', //缺陷发现日期
                defect_content: '', //缺陷内容
                qx_file_list: [], //缺陷图片
                xq_file_list: [], //消缺图片
                dual_method: '10', //缺陷安排处理
                solve_time_start: '', //消缺开始时间
                solve_time_end: '', //消缺结束时间
                solver: '', //消缺负责人
                solve_content: '', //消缺过程描述
            },
            defentCheckFormRules: {
                defect_source: [
                    {
                        required: true,
                        message: '请选择缺陷来源',
                        trigger: 'change',
                    },
                ],
                defect_level: [
                    {
                        required: true,
                        message: '请选择缺陷性质',
                        trigger: 'change',
                    },
                ],
                founder: [
                    {
                        required: true,
                        message: '请填写缺陷发现人',
                        trigger: 'blur',
                    },
                ],
                founder_phone: [
                    {
                        required: true,
                        message: '请填写联系电话',
                        trigger: 'blur',
                    },
                ],
                found_time: [
                    {
                        required: true,
                        message: '请选择缺陷发现日期',
                        trigger: 'change',
                    },
                ],
                defect_content: [
                    {
                        required: true,
                        message: '请填写缺陷内容',
                        trigger: 'blur',
                    },
                ],
                dual_method: [
                    {
                        required: true,
                        message: '请选择处理方式',
                        trigger: 'change',
                    },
                ],
                solve_time_start: [
                    {
                        required: true,
                        message: '请选择消缺开始时间',
                        trigger: 'change',
                    },
                ],
                solve_time_end: [
                    {
                        required: true,
                        message: '请选择消缺结束时间',
                        trigger: 'change',
                    },
                ],
                solver: [
                    {
                        required: true,
                        message: '请填写消缺负责人',
                        trigger: 'blur',
                    },
                ],
                solve_content: [
                    {
                        required: true,
                        message: '请填写消缺内容',
                        trigger: 'blur',
                    },
                ],
            },
            qxFileImgs: [],
            xqFileImgs: [],
            defect_id: '',
            lookLook: false,
        };
    },
    created() { },
    mounted() { },
    watch: {
        defentDialogVisible(newVal) {
            if (newVal) {
                this.getUnitDocTreeList();
                this.getDefectSource();
                this.getDefectLevel();
            }
        },
        defect_id(newVal) {
            if (newVal) {
                this.defect_id = newVal;
                this.getDefectById();
            }
        },
        lookLook(newVal) {
            if (newVal) {
                this.lookLook = newVal;
            }
        },
    },
    methods: {
        //获取缺陷来源
        getDefectSource() {
            api.getCodelistByKind({
                code_kind: 'defect_source',
            }).then((res) => {
                if (res) {
                    this.defectSource = res.bus_json[0].codelists;
                }
            });
        },
        //获取缺陷性质
        getDefectLevel() {
            api.getCodelistByKind({
                code_kind: 'defect_level',
            }).then((res) => {
                if (res) {
                    this.defectLevels = res.bus_json[0].codelists;
                }
            });
        },
        getUnitDocTreeList() {
            api.getUnitDocTreeList({}).then((res) => {
                if (res) {
                    this.treeData = res.bus_json;
                    // let formatData = this.treeData && this.treeData[0];
                    // this.defaultCheckKeys = [formatData.tree_id];
                    // this.defaultExpandedKeys = [formatData.tree_id];
                    // this.tree_id = this.defaultCheckKeys[0];
                    // this.$nextTick(() => {
                    //     this.$refs.myTree.handleCheckBoxClick(formatData);
                    // });
                }
            });
        },
        getDefectById() {
            api.getDefectById({
                defect_id: this.defect_id,
            }).then((res) => {
                if (res) {
                    this.defentCheckForm.defect_source =
                        res.bus_json.defect_source;
                    this.defentCheckForm.defect_level =
                        res.bus_json.defect_level;
                    this.defentCheckForm.founder = res.bus_json.founder;
                    this.defentCheckForm.founder_phone =
                        res.bus_json.founder_phone;
                    this.defentCheckForm.found_time = res.bus_json.found_time;
                    this.defentCheckForm.defect_content =
                        res.bus_json.defect_content;
                    this.defentCheckForm.dual_method = res.bus_json.dual_method;
                    this.defentCheckForm.solve_time_start =
                        res.bus_json.solve_time_start;
                    this.defentCheckForm.solve_time_end =
                        res.bus_json.solve_time_end;
                    this.defentCheckForm.solver = res.bus_json.solver;
                    this.defentCheckForm.solve_content =
                        res.bus_json.solve_content;
                    this.tree_id = res.bus_json.tree_id;
                    this.$nextTick(() => {
                        this.$refs.myTree.handleCheckBoxClick({
                            tree_id: this.tree_id,
                        });
                    });

                    this.defentCheckForm.qx_file_list =
                        res.bus_json.qx_file_list;
                    this.defentCheckForm.xq_file_list =
                        res.bus_json.xq_file_list;

                    if (res.bus_json.qx_file_list) {
                        res.bus_json.qx_file_list.forEach((item) => {
                            this.qxFileImgs.push({
                                file_id: item.file_id,
                                url:
                                    process.env.VUE_APP_3D_URL +
                                    '/' +
                                    item.file_path,
                            });
                        });
                    }
                    if (res.bus_json.xq_file_list) {
                        res.bus_json.xq_file_list.forEach((item) => {
                            this.xqFileImgs.push({
                                file_id: item.file_id,
                                url:
                                    process.env.VUE_APP_3D_URL +
                                    '/' +
                                    item.file_path,
                            });
                        });
                    }
                }
            });
        },

        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.defaultExpandedKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.tree_id = select.tree_id;
        },
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function (obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === '1') {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === '0') {
                    //虚点
                    if (!firstPoint.point_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function (arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                },
            };
        },
        // 缺陷图片上传
        uploadFile(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!,请重新上传！');
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('file_type', '30');
            // const loading = this.$loading({
            //     lock: true,
            //     text: "正在上传中...",
            //     spinner: "el-icon-loading",
            //     background: "rgba(255, 255, 255, 0.5)"
            // });
            api.uploadAvatar(formData).then((res) => {
                if (res) {
                    this.qxFileImgs.push({
                        file_id: res.bus_json.file_id,
                        url:
                            process.env.VUE_APP_3D_URL +
                            '/' +
                            res.bus_json.file_path,
                    });
                    this.defentCheckForm.qx_file_list = this.qxFileImgs;
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                }
                // loading.close();
            });
        },
        handleRemove(file) {
            this.defentCheckForm.qx_file_list.forEach((item) => {
                if (file.file_id == item.file_id) {
                    this.defentCheckForm.qx_file_list.splice(item, 1);
                }
            });
            this.qxFileImgs = this.qxFileImgs.filter(
                (item) => item.file_id !== file.file_id
            );
        },
        // 缺陷图片上传
        uploadFile_xq(file) {
            const isLt2M = file.file.size / 1024 / 1024 < 1;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!,请重新上传！');
                return;
            }
            let formData = new FormData();
            formData.append('file', file.file);
            formData.append('file_type', '40');
            // const loading = this.$loading({
            //     lock: true,
            //     text: "正在上传中...",
            //     spinner: "el-icon-loading",
            //     background: "rgba(255, 255, 255, 0.5)"
            // });
            api.uploadAvatar(formData).then((res) => {
                if (res) {
                    this.xqFileImgs.push({
                        file_id: res.bus_json.file_id,
                        url:
                            process.env.VUE_APP_3D_URL +
                            '/' +
                            res.bus_json.file_path,
                    });
                    this.defentCheckForm.xq_file_list = this.xqFileImgs;
                    this.$message({
                        type: 'success',
                        message: res.error_msg,
                    });
                }
                // loading.close();
            });
        },
        handleRemove_xq(file) {
            this.defentCheckForm.xq_file_list.forEach((item) => {
                if (file.file_id == item.file_id) {
                    this.defentCheckForm.xq_file_list.splice(item, 1);
                }
            });
            this.xqFileImgs = this.xqFileImgs.filter(
                (item) => item.file_id !== file.file_id
            );
        },
        //保存
        changeCommit(formName) {
            this.$refs[formName].validate((valid) => {
                console.log('form: ', this.defentCheckForm);
                if (valid) {
                    api.saveDefect({
                        defect_id: this.defect_id,
                        tree_id: this.tree_id,
                        defect_source: this.defentCheckForm.defect_source,
                        defect_level: this.defentCheckForm.defect_level,
                        founder: this.defentCheckForm.founder,
                        founder_phone: this.defentCheckForm.founder_phone,
                        found_time: this.defentCheckForm.found_time,
                        defect_content: this.defentCheckForm.defect_content,
                        dual_method: this.defentCheckForm.dual_method,
                        solve_time_start: this.defentCheckForm.solve_time_start,
                        solve_time_end: this.defentCheckForm.solve_time_end,
                        solver: this.defentCheckForm.solver,
                        solve_content: this.defentCheckForm.solve_content,
                        qx_file_list: this.defentCheckForm.qx_file_list,
                        xq_file_list: this.defentCheckForm.xq_file_list,
                    }).then((res) => {
                        if (res) {
                            this.$message({
                                type: 'success',
                                message: res.error_msg,
                            });
                            this.defentDialogVisible = false;
                            this.$emit('updateBeginData');
                        }
                    });
                }
            });
        },
        closeDialog() {
            this.$refs['defentCheckForm'].resetFields();
            this.$refs['defentCheckForm'].clearValidate();
            this.defentDialogVisible = false;
            this.$emit('update:defentDialogVisible', this.defentDialogVisible);
            this.lookLook = false;
            this.$emit('update:lookLook', this.lookLook);
            this.qxFileImgs = [];
            this.xqFileImgs = [];
            this.tree_id = '';
            this.defect_id = '';
            this.$emit('update:defect_id', '');
        },
    },
};
</script>
<style lang="scss">
.defentDialogClass {
    .el-dialog {
        // height: 600px;
        .el-dialog__body {
            height: 100%;
            padding: 20px !important;
        }
    }
    .el-scrollbar__wrap {
        overflow-x: hidden;
    }
    .avatar-uploader {
        text-align: left;
        .el-upload--picture-card {
            width: 100px;
            height: 100px;
            line-height: 100px;
        }
        .el-upload-list--picture-card .el-upload-list__item {
            width: 100px;
            height: 100px;
        }
    }
}
</style>
